import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import CircularProgress from "@mui/material/CircularProgress";
import Alert from "@mui/material/Alert";
import { type FieldErrors, type TopicsState, type RelevantTopicAnchorRow, type GeneralTopicItem, type UrlGroup } from "./useTaskCreation";
import { RelevantTopicTable } from "./RelevantTopicTable";

export function RelevantTopicAnchorsSection(props: {
  anchorsText: string;
  anchorInputMode: UrlGroup["anchorInputMode"];
  topicsState: TopicsState;
  groupErrors: FieldErrors;
  disabled: boolean;
  onChangeAnchorsText: (value: string) => void;
  onProcess: () => void;
  onResetToTextarea: () => void;
  onRetryTopics: () => void;
  onSetAnchorRow: (
    anchorIndex: number,
    field: keyof RelevantTopicAnchorRow,
    value: string | number,
  ) => void;
}) {
  const { anchorInputMode, topicsState } = props;
  const isProcessing = topicsState.kind === "loading";

  const topics: GeneralTopicItem[] = topicsState.kind === "loaded" ? topicsState.topics : [];

  return (
    <Box mb={2}>
      {anchorInputMode.mode === "table" ? (
        <RelevantTopicTable
          rows={anchorInputMode.rows}
          topics={topics}
          topicsState={topicsState}
          groupErrors={props.groupErrors}
          disabled={props.disabled}
          onResetToTextarea={props.onResetToTextarea}
          onRetryTopics={props.onRetryTopics}
          onSetAnchorRow={props.onSetAnchorRow}
        />
      ) : (
        <>
          <TextField
            label="Анкоры"
            placeholder={"anchor,count\nanchor,count,uniqueness_percent,topic"}
            value={props.anchorsText}
            error={!!props.groupErrors.anchors}
            helperText={
              props.groupErrors.anchors ??
              "Краткий: anchor,количество; полный: anchor,количество,уникальность%,тема"
            }
            disabled={props.disabled}
            onChange={(event) => props.onChangeAnchorsText(event.target.value)}
            multiline
            minRows={4}
            fullWidth
            size="small"
            sx={{ mb: 1 }}
          />
          <Button
            variant="outlined"
            size="small"
            disabled={props.disabled || isProcessing}
            onClick={props.onProcess}
          >
            {isProcessing ? <><CircularProgress size={14} sx={{ mr: 1 }} />Обработка…</> : "Обработать"}
          </Button>
          {topicsState.kind === "error" && (
            <Alert
              severity="error"
              sx={{ mt: 1 }}
              action={
                <Button color="inherit" size="small" onClick={props.onRetryTopics}>
                  Повторить
                </Button>
              }
            >
              {topicsState.message}
            </Alert>
          )}
        </>
      )}
    </Box>
  );
}
